import { FC } from 'react'

const DinersIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.625"
      y="1.125"
      width="38.75"
      height="23.75"
      rx="4.375"
      fill="#F5F6F8"
    />
    <rect
      x="0.625"
      y="1.125"
      width="38.75"
      height="23.75"
      rx="4.375"
      stroke="#E5E5EA"
      strokeWidth="1.25"
    />
    <path
      d="M17.9944 5.77063V5.75H22.9284V5.77063C26.7956 6.0575 29.7891 9.32094 29.7891 13.25C29.7891 17.18 26.7956 20.4434 22.9284 20.7303V20.75H17.9944V20.7303C14.1263 20.4434 11.1328 17.18 11.1328 13.25C11.1328 9.32094 14.1263 6.0575 17.9944 5.77063Z"
      fill="#0165AC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1172 13.2419C12.1172 16.8325 14.9887 19.7425 18.5316 19.7425C22.0744 19.7425 24.9459 16.8316 24.9459 13.2419C24.9459 9.65219 22.0744 6.74219 18.5316 6.74219C14.9887 6.74219 12.1172 9.65219 12.1172 13.2419ZM17.0512 9.0025C15.2803 9.64 14.0981 11.3378 14.0981 13.2419C14.0981 15.1459 15.2803 16.8447 17.0512 17.4822V9.0025ZM20.0119 17.4822C21.7819 16.8447 22.965 15.1459 22.965 13.2419C22.965 11.3387 21.7819 9.64 20.0119 9.0025V17.4822Z"
      fill="white"
    />
  </svg>
)

export default DinersIcon
